import { TemplateType } from "../enums/template-type";
import { Template } from "../models/Template";

export function isAutomationTemplate(template: Template) {
  if ([
    TemplateType.ProductFollowup
  ].includes(template.type)) {
    return true;
  }

  return false;
}
